import { memo, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useUpdateSubject } from "../../../hooks/query/useUpdateSubject";

type SubjectTagProps = {
    subject: {
        id: number;
        name: string;
    };
    onEdit?: (branchId: number) => void;
    onDelete?: (branchId: number) => void;
};

const BORDER_CLASSES = [
    "border-l-red-500",
    "border-l-blue-500",
    "border-l-green-500",
    "border-l-yellow-500",
    "border-l-purple-500",
    "border-l-pink-500",
];

function SubjectTag(props: SubjectTagProps) {
    const { subject, onEdit, onDelete } = props;
    const { id, name } = subject;
    const [type, setType] = useState<string>("");
    const [editData, setEditData] = useState({
        name
    });
    const borderClass = BORDER_CLASSES[id % BORDER_CLASSES.length];


    const handleEdit = () => {
        setType("edit");
        onEdit?.(id);
    }

    const handleCancel = () => {
        setType("");
    }


    useEffect(() => {
        if (type === "edit") {
            setEditData({ name });
        }
    }, [type, name]);

    const { mutate: updateSubject } = useUpdateSubject();

    const handleSave = () => {
        updateSubject(
            {
                id,
                data: {
                    name: editData.name,
                },
            },
            {
                onSuccess: () => {
                    toast.success("Cập nhật chi nhánh thành công!");
                    setType("");
                },
                onError: () => {
                    toast.error("Cập nhật chi nhánh thất bại!");
                },
            }
        );
    };

    return (
        <div
            className={`border-l-[18px] border-t-[1px] border-r-[1px] border-b-[1px] rounded-[16px] ${borderClass} p-3 rounded text-white flex justify-between gap-4`}
        >
            {type !== 'edit' ? (<div>
                <h3 className="text-[16px] font-bold">{name}</h3>
            </div>) : (
                <div>
                    <input
                        className="text-black rounded-[4px] outline-none w-[300px] py-[4px] px-[8px]"
                        value={editData.name}
                        onChange={e =>
                            setEditData(prev => ({ ...prev, name: e.target.value }))
                        }
                    />
                </div>
            )
            }
            <div className="flex flex-col gap-2">
                {type === "edit" ? (<button
                    className="px-3 py-1 text-sm rounded bg-blue-500 text-white hover:bg-blue-600"
                    onClick={handleSave}
                >
                    Lưu
                </button>) :
                    (<button
                        className="px-3 py-1 text-sm rounded bg-blue-500 text-white hover:bg-blue-600"
                        onClick={handleEdit}
                    >
                        Chỉnh sửa
                    </button>)}
                {type === "edit" && <button
                    className="min-w-[85px] min-h-[30px] px-3 py-1 text-sm rounded bg-gray-500 text-white hover:bg-gray-600"
                    onClick={handleCancel}
                >
                    Hủy
                </button>}
                {type !== "edit" && <button
                    className="px-3 py-1 text-sm rounded bg-red-500 text-white hover:bg-red-600"
                    onClick={() => onDelete?.(id)}
                >
                    Xóa
                </button>}
            </div>
        </div>
    );
}

export default memo(SubjectTag);
